import { render, staticRenderFns } from "./HeadingIntro.vue?vue&type=template&id=4b2ccde6&scoped=true&"
import script from "./HeadingIntro.vue?vue&type=script&lang=js&"
export * from "./HeadingIntro.vue?vue&type=script&lang=js&"
import style0 from "./HeadingIntro.vue?vue&type=style&index=0&id=4b2ccde6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2ccde6",
  null
  
)

export default component.exports